import script from "./GoogleRating.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleRating.vue?vue&type=script&setup=true&lang=js"

import "./GoogleRating.vue?vue&type=style&index=0&id=80d6208a&scoped=true&lang=css"

import exportComponent from "/__w/oscar/oscar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80d6208a"]])

export default __exports__